import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import { CopyButton, Dropdown, useToast } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
export type IdItem = {
  label: string;
  value: string;
};
type IdDropdownProps = {
  items: IdItem[];
};
const IdMenuItems = t0 => {
  const $ = _c(11);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header.idDropdown"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    toast
  } = useToast();
  let t2;
  if ($[1] !== t || $[2] !== toast) {
    t2 = async item => {
      ;
      try {
        await navigator.clipboard.writeText(item.value);
        toast({
          title: t(_temp),
          description: `${item.label} ${t(_temp2)}`
        });
      } catch (t3) {
        const _ = t3;
      }
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleCopy = t2;
  let t3;
  if ($[4] !== handleCopy || $[5] !== items) {
    let t4;
    if ($[7] !== handleCopy) {
      t4 = item_0 => <Dropdown.Item key={item_0.label} onClick={() => handleCopy(item_0)} className="h-fit"><div className="flex flex-col gap-1"><p className="text-caption-2 text-tertiary">{item_0.label}</p><p className="text-snippet-2">{item_0.value}</p></div></Dropdown.Item>;
      $[7] = handleCopy;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = items.map(t4);
    $[4] = handleCopy;
    $[5] = items;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <Dropdown.Group>{t3}</Dropdown.Group>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const IdDropdown = t0 => {
  const $ = _c(12);
  const {
    items
  } = t0;
  const hasSingleId = items.length === 1;
  const mainId = items[0];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "top"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = mainId?.value || "";
  const t3 = mainId?.value;
  let t4;
  if ($[1] !== t3) {
    t4 = <div className="text-snippet-2 text-primary group-hover:text-secondary max-md:truncate">{t3}</div>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <div className="flex items-center h-6 gap-2 px-3 group max-md:min-w-0"><CopyButton size="compact" tooltip={t1} contentToCopy={t2} className="max-md:min-w-0">{t4}</CopyButton></div>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hasSingleId || $[7] !== items) {
    t6 = hasSingleId ? null : <Dropdown.Root><Dropdown.Trigger asChild={true}><div className="group"><button className={cx("flex items-center justify-start pl-1 w-[28px] h-full rounded-r-full relative", "before:content-[\"\"] before:w-[1px] before:h-3 before:bg-[#e2e2e2] before:absolute before:top-1/2 before:left-0 before:-translate-x-1/2 before:-translate-y-1/2", "hover:bg-hover-control group-data-[state=open]:bg-senary/70")} type="button"><IcoChevronDown16 className="transition-transform duration-100 ease-in-out group-data-[state=open]:rotate-180" /></button></div></Dropdown.Trigger><Dropdown.Content sideOffset={4}><IdMenuItems items={items} /></Dropdown.Content></Dropdown.Root>;
    $[6] = hasSingleId;
    $[7] = items;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex items-center overflow-hidden rounded-full bg-secondary">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export { IdMenuItems };
export default IdDropdown;
function _temp($) {
  return $.copied;
}
function _temp2($_0) {
  return $_0.copiedToClipboard;
}